module.exports = __webpack_public_path__ + "assets/filters-a09794.svg";